import React, { createContext, useContext, useEffect, useState } from 'react';
import { GetCookieData, GetCookieToken } from '../Cookie/GetCookie';
import axios from 'axios';
import { CheckBudgetYear } from '../Function/CheckBudgetYear';

const LayOutConText = createContext();

export const useLayOutConText = () => useContext(LayOutConText);

function LayOutContext({ children }) {

  const baseURL = process.env.REACT_APP_API_CORS
  
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;
  const user_position = GetCookieData("userPosition");

  const [layOut, setLayOut] = useState('');
  const [userInfo, setUserInfo] = useState([])
  const [numApprove, setNumApprove] = useState()

  const getUserInfo = async () => {
    try {
      const res = await axios.get(baseURL+"/api/users/info", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      setUserInfo(prev => res?.data?.result)
    } catch (err) {
      console.error(err);
    }
  }

  // const getLeaveDataTable = async (
  //   ) => {
  //     try {
  //       const url = baseURL + `/api/leave/datatable`;
  //       const params = new URLSearchParams({
  //         page: 1,
  //         size: 100000,
  //         "order[0]": "created_date",
  //         "order[1]": "DESC",
  //         "filter[budget_year][0]": CheckBudgetYear() || undefined,
  //       });
  //       const config = {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //         params,
  //       };
  //       const res = await axios.get(url, config);
  //       console.log("Leave Datatable: ", res);
  //       await getApproveDataTable(res?.data?.result)
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  // const getApproveDataTable = async (responLeave) => {
  //   try {
  //     const url = baseURL + `/api/leave/approve/datatable`;
  //     const config = {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //       params: {
  //         page: 1,
  //         size: 10000,
  //         "order[0]": "created_date",
  //         "order[1]": "DESC",
  //         "filter[approve_id][0]": user_id,
  //         "filter[approve_status][0]": "0",
  //         "filter[approve_final][0]": "0",
  //         "filter[budget_year][1]": CheckBudgetYear(),
  //       },
  //     };
  //     const res = await axios.get(url, config);
  //     console.log("getApproveDataTable: ", res);
  //     console.log("responLeave: ", responLeave);
  //     let arrForDataApp = []
  //     res?.data?.result &&
  //       res?.data?.result?.map((item) => {
  //         let leaveNameFromLeaveData = responLeave?.find(
  //           (a) =>
  //             parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
  //             a?.leave_status !== "8"
  //         )?.leave_name;
  //         let checkAppLeaveIdNStatus = responLeave?.find(
  //           (a) =>
  //             parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
  //             a?.leave_status !== "8"
  //         )?.leave_status;
  //         let newOBJ = {
  //           ...item,
  //           leave_name: leaveNameFromLeaveData,
  //           leave_status: checkAppLeaveIdNStatus,
  //         };
  //         if (
  //           responLeave?.some(
  //             (a) =>
  //               parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
  //               a?.leave_status !== "8"
  //           )
  //         ) {
  //           arrForDataApp.push(newOBJ)
  //         }
  //       });
  //     console.log("arrForDataApp: ",arrForDataApp)
  //     setNumApprove(arrForDataApp?.length)
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  useEffect(() => {
    getUserInfo();
    // getLeaveDataTable(1);
  },[])

  // useEffect(() => {
  //   if(numApprove) {
  //     console.log("numApprove: ", numApprove)
  //   }
  // },[numApprove])

  return (
    <LayOutConText.Provider value={{ layOut, setLayOut, numApprove, setNumApprove, userInfo }}>
      {children}
    </LayOutConText.Provider>
  );
}

export default LayOutContext;
